module.exports = __webpack_public_path__ + "static/a1d1-1-01ca2c25a026802a18eddf06eba11877.svg";